import {Injectable} from "@angular/core";
import {SyncStatusExtended} from "app/account-governance/account-governance-pages/cloud-account-governance-page/functional-group/functional-group-base.component";
import {Subject} from "rxjs";

@Injectable()
export class SyncStatusService
{

    private m_syncUpdateSubject = new Subject<SyncStatusExtended | void>();
    syncUpdate$               = this.m_syncUpdateSubject.asObservable();

    private m_statusValueSubj = new Subject<any>();
    statusValue$            = this.m_statusValueSubj.asObservable();

    private m_rerunTriggeredSubj = new Subject<any>();
    rerunTriggered$            = this.m_rerunTriggeredSubj.asObservable();

    

    setStatus(status: void | any)
    {
        this.m_statusValueSubj.next(status);
    }

    getStatus()
    {
        return this.m_statusValueSubj.asObservable();
    }

    notifyRerunTriggered(statusKey: string): void 
    {

        this.m_rerunTriggeredSubj.next(statusKey);
    }

}
